import type { IUser } from "@/apps/recruiter/interfaces"
import client from "@/common/client"
import type { ILoginResponse } from "@/common/interfaces"

export interface ILoginForm {
    email?: string
    password?: string
    loading?: boolean
    invalidCredentials?: boolean
}

const userRepository = {
    get: (): Promise<IUser> => client.get("/api/recruiter/profile"),
    login: (form: ILoginForm): Promise<ILoginResponse> => client.post("/api/recruiter/login", form),
    getCredit: (): Promise<string> => client.get("/api/recruiter/profile/credit")
}

export default userRepository
